import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function LateHours() {
  const {
    t
  } = useLanguage();
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} className="relative overflow-hidden" data-id="element-268">
      <div className="relative aspect-video w-full" data-id="element-269">
        <img src="https://cdn.magicpatterns.com/uploads/2YikPANiSfEoJMwgFBeVFo/heylloyd-image-1775236695713.png" alt="VillaConBarberShop de noche" className="absolute inset-0 w-full h-full object-cover" data-id="element-270" />
        <div className="absolute inset-0 bg-black/50" data-id="element-271"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[20vw] font-heading font-bold text-white/10 whitespace-nowrap pointer-events-none z-0 select-none" data-id="element-272">
          9 PM
        </div>
        <div className="absolute inset-0 flex items-center justify-center z-10 px-4" data-id="element-273">
          <div className="max-w-3xl mx-auto text-center" data-id="element-274">
            <p className="font-heading text-lg md:text-2xl text-white/80 uppercase tracking-widest mb-6" data-id="element-275">
              {t('lateHours.subtitle')}
            </p>
            <h2 className="font-heading text-4xl md:text-7xl font-bold text-barber-gold uppercase mb-8 md:mb-12 drop-shadow-lg" data-id="element-276">
              {t('lateHours.heading1')} <br className="md:hidden" data-id="element-277" />{' '}
              {t('lateHours.heading2')}
            </h2>
            <div className="space-y-4 md:space-y-6 text-lg md:text-2xl text-white font-light" data-id="element-278">
              <p className="font-bold text-xl md:text-3xl mb-6 md:mb-8" data-id="element-279">
                {t('lateHours.line1')}
              </p>
              <p className="text-white/70" data-id="element-280">{t('lateHours.line2')}</p>
              <p className="text-white/70" data-id="element-281">{t('lateHours.line3')}</p>
              <p className="text-white/70" data-id="element-282">{t('lateHours.line4')}</p>
              <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-white/20" data-id="element-283">
                <p className="font-heading text-2xl md:text-4xl text-white uppercase tracking-wide" data-id="element-284">
                  {t('lateHours.line5')}{' '}
                  <span className="text-barber-gold" data-id="element-285">
                    {t('lateHours.line6')}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>;
}